import pick from 'lodash/pick.js';

/**
 * @pickDataAttributes filters the "data-..." atributes from the props object
 *
 * @param {object} props Object to filter through
 * @param {string | undefined} componentName The component name
 * @returns {DataAttributes} Object with all properties that contain `data-`
 */

var pickDataAttributes = function pickDataAttributes(props, componentName) {
  // @ts-ignore
  var dataAttributes = pick(props, Object.keys(props).filter(function (prop) {
    return prop.includes('data-');
  }));

  // Assign default data attribute if passed component name
  if (!dataAttributes['data-component-type'] && componentName) {
    dataAttributes['data-component-type'] = componentName;
  }
  return dataAttributes;
};
export { pickDataAttributes };